import { render, staticRenderFns } from "./FileDropzone.vue?vue&type=template&id=fd9d82cc&scoped=true&"
import script from "./FileDropzone.vue?vue&type=script&lang=js&"
export * from "./FileDropzone.vue?vue&type=script&lang=js&"
import style0 from "./FileDropzone.vue?vue&type=style&index=0&id=fd9d82cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9d82cc",
  null
  
)

export default component.exports